import { call, put, all, takeLatest } from 'redux-saga/effects';
import {
  createCouponAct,
  deleteCouponAct,
  getCouponsAct,
  updateCouponAct,
} from './actions';
import {
  createCouponApi,
  deleteCouponApi,
  getCouponsApi,
  updateCouponApi,
} from '../../api/coupon.api';
import { getErrorMessage } from '../../utils/error.util';
import { addMessage } from '../ToastMessagesManager/actions';
import messages from '../../components/CouponList/messages';

function* fetchCoupons({ payload }) {
  const { loadingState, params } = payload;
  if (loadingState === 1) {
    try {
      const { data: coupons } = yield call(getCouponsApi, params);
      if (coupons) {
        yield put(getCouponsAct(2, params, coupons));
      } else {
        throw new Error('Something went wrong');
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      yield all([
        put(addMessage({ message: errorMessage, variant: 'error' })),
        put(getCouponsAct(3)),
      ]);
    }
  }
}

function* createCoupon({ payload }) {
  const { loadingState, data } = payload;
  if (loadingState === 1) {
    try {
      const { data: createdCoupon } = yield call(createCouponApi, data);
      if (createdCoupon) {
        yield all([
          put(
            addMessage({ message: messages.createSuccess, variant: 'success' }),
          ),
          put(createCouponAct(2, createdCoupon)),
        ]);
      } else {
        throw new Error('Something went wrong');
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      yield all([
        put(addMessage({ message: errorMessage, variant: 'error' })),
        put(createCouponAct(3)),
      ]);
    }
  }
}

function* updateCoupon({ payload }) {
  const { loadingState, data, id } = payload;
  if (loadingState === 1) {
    try {
      const { data: updatedCoupon } = yield call(updateCouponApi, id, data);
      if (updatedCoupon) {
        yield all([
          put(
            addMessage({ message: messages.updateSuccess, variant: 'success' }),
          ),
          put(updateCouponAct(2, id, updatedCoupon)),
        ]);
      } else {
        throw new Error('Something went wrong');
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      yield all([
        put(addMessage({ message: errorMessage, variant: 'error' })),
        put(updateCouponAct(3)),
      ]);
    }
  }
}

function* deleteCoupon({ payload }) {
  const { loadingState, id } = payload;
  if (loadingState === 1) {
    try {
      const { data } = yield call(deleteCouponApi, id);
      if (data) {
        yield all([
          put(
            addMessage({ message: messages.deleteSuccess, variant: 'success' }),
          ),
          put(deleteCouponAct(2, id)),
        ]);
      } else {
        throw new Error('Something went wrong');
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      yield all([
        put(addMessage({ message: errorMessage, variant: 'error' })),
        put(deleteCouponAct(3)),
      ]);
    }
  }
}

// Individual exports for testing
export default function* couponSaga() {
  yield takeLatest(getCouponsAct.toString(), fetchCoupons);
  yield takeLatest(createCouponAct.toString(), createCoupon);
  yield takeLatest(updateCouponAct.toString(), updateCoupon);
  yield takeLatest(deleteCouponAct.toString(), deleteCoupon);
}
